<template>
  <BaseForm class="noprogress">
    <template v-slot:header >
      <template v-if="!message">{{ $t('renew_404_header1') }} <nobr>{{ $t('renew_404_header2') }}</nobr></template>
    </template>
    <div class="warning" v-if="message">
        <div class="titleWarn">{{ message }}</div>
    </div>
    <div class="renewNotFoundTitle" v-if="message">{{ $t('renew_get_now') }}</div>
    <div class="offerMain__insurance renew__insurance">
      <ul>
        <li
        v-for="(app, index) of appNamesOrder" :key="index"
        >
          <a :href="`/${locale}/${appsList[app].url}`">
            <div class="footerNew__insurance-item" :class="[app]">
            </div>
            <span>{{ getAppTitle(app) }}</span>
          </a>
        </li>
      </ul>
    </div>
  </BaseForm>
</template>

<script>
import { landingAppsInfo, BaseForm } from 'qic-components'
export default {
  name: 'NotFound',
  props: [
    'message'
  ],
  data () {
    return {
      appsList: landingAppsInfo.appsList,
      appNamesOrder: landingAppsInfo.footerOrder
    }
  },
  components: {
    BaseForm
  },
  computed: {
    locale () {
      return this.$i18n.locale
    }
  },
  methods: {
    getAppImg (name) {
      return require(`@/assets/images/applogo/${name}.png`)
    },
    getAppTitle (app) {
      if (this.$te(this.appsList[app].footerTitleT)) {
        return this.$t(this.appsList[app].footerTitleT)
      }
      return this.$t(this.appsList[app].headerTitle)
    }
  }
}
</script>

<style lang="scss" scoped>
  .warning {
    margin-bottom: 40px;
    .titleWarn{
      font-weight: 500;
    }
  }
  .renewNotFoundTitle{
    font-weight: 500;
    font-size: 32px;
    line-height: 40px;
    text-align: center;
    color: #1C1C1C;
    margin-bottom: 32px;
  }
</style>
